
import { ChangeDetectorRef, Component, ViewEncapsulation } from '@angular/core';
import { OccProductSearchAdapter, SearchConfig } from '@spartacus/core';
import { ActiveFacetsComponent, FacetService } from '@spartacus/storefront';
import { BehaviorSubject, Observable } from 'rxjs';
import { ProductListService } from '../../../../kbs-site-doc-search-page/service/Product-list/product-list.service';



@Component({
  selector: 'app-facet-active-kb',
  templateUrl: './facet-active-kb.component.html',
  styleUrls: ['./facet-active-kb.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None
})
export class FacetActiveKbComponent extends ActiveFacetsComponent {
  private categoryFacetSubject = new BehaviorSubject<any>(null);
  oTcategoryData$ = this.categoryFacetSubject.asObservable();
  otherTabFacetAvailable: boolean = false;
  defaultPageSize: number = 10;
  initalPageNum: number = 0;
  facetTabIndex: any = 0;
  categoryCode: any;

  /* DocList$!: Observable<any>;
  SoftwareList$!: Observable<any>;
  CrossRefList$!: Observable<any>;
  TrainingList$!: Observable<any>; */

  constructor(facetService: FacetService,
    public productListService: ProductListService,
    public searchService: OccProductSearchAdapter,) {
    super(facetService);
  }
  ngOnInit() {
    this.productListService.selectedTabIndex.subscribe(data => {
      this.facetTabIndex = data;
    })
  }

  FacetClick(e: any, model?: any) {
    const queryValue = this.productListService.DecodeQuery(e.removeQuery.query.value);


   /*  if (this.facetTabIndex == 2) {
      this.productListService.getDocumentDetails(this.defaultPageSize, queryValue, this.initalPageNum).subscribe(data => {
        this.productListService.countDetails$.next({
          ...this.productListService.countDetails$.value,
          docModel: data,
        });
      })
    } else if (this.facetTabIndex == 3) {
      this.productListService.getSoftwareDetails(this.defaultPageSize, queryValue, this.initalPageNum).subscribe(data => {
        this.productListService.countDetails$.next({
          ...this.productListService.countDetails$.value,
          softwareModel: data,
        });
      })
    }
    else if (this.facetTabIndex == 1) {
      this.productListService.getCrossRefDetails(this.defaultPageSize, queryValue, this.initalPageNum).subscribe(data => {
        data = this.removeSortAndAssignEmpty(data);
        this.productListService.countDetails$.next({
          ...this.productListService.countDetails$.value,
          crossRefModel: data,
        });
      })
    }
    else if (this.facetTabIndex == 4) {
      this.productListService.getTrainingDetails(this.defaultPageSize, queryValue, this.initalPageNum).subscribe(data => {
        this.productListService.countDetails$.next({
          ...this.productListService.countDetails$.value,
          trainingModel: data,
        });
      })
    } else if (this.facetTabIndex == 0) {
      this.searchService.search(queryValue, model.pagination).subscribe(data => {
        data = this.removeSortAndAssignEmpty(data);
        this.productListService.countDetails$.next({
          ...this.productListService.countDetails$.value,
          productModel: data,
        });
      })
    }
    else */ if (this.facetTabIndex == 7) {
      const docQuery = this.productListService.getCustomDocQuery(e.removeQuery.query.value);
      this.productListService.getCustomDocumentDetails(docQuery, this.defaultPageSize, this.initalPageNum).subscribe((x) => {
        this.productListService.seperateDocDetails$.next(x);
      });
    }
    /* else if (this.facetTabIndex == 8) {
      const softQuery = this.productListService.getCustomSoftwareQuery(e?.removeQuery?.query?.value);
      this.productListService.getCustomSoftwareDetails(softQuery, this.defaultPageSize, this.initalPageNum).subscribe((x) => {
        this.productListService.seperateSoftDetails$.next(x);
      });
    } */

  }

  removeSortCode(data: any[]) {
    return data?.filter((sort) => sort.code !== 'salesStatusSortValue-asc');
  }
  removeSortAndAssignEmpty(productModel: any) {
    return {
      ...productModel,
      sorts: this.removeSortCode(productModel.sorts),
      pagination: {
        ...productModel.pagination,
        sort: productModel.pagination.sort !== 'salesStatusSortValue-asc' ? productModel.pagination.sort : null,
      },
    };
  }
  ngOnDestroy() {
  }
}
